import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError } from 'rxjs';
import { AccountService } from '../../services/account.service';
import { SnackbarService } from '../../services/snackbar.service';
import { LocalStorageToken } from '../../util/constant';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const accountService = inject(AccountService);
  const snackbar = inject(SnackbarService);
  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.statusText === 'Unknown Error') {
        localStorage.removeItem(LocalStorageToken);
        accountService.setUser(null);
        router.navigate(['/login']);
      }
      if (error.status === 400) {
        if (error.error && error.error.errors) {
          const modelStateErrors = [];
          for (const key in error.error.errors) {
            if (error.error.errors.hasOwnProperty(key)) {
              modelStateErrors.push(...error.error.errors[key]);
            }
          }
          throw modelStateErrors.flat();
        } else if (error.error && typeof error.error === 'string') {
          snackbar.error(error.error);
        }
      } else if (error.status === 401) {
        accountService.logout();
        snackbar.error('Your session has expired. Please log in again.');
      } else if (error.status === 404) {
        if (error.error && typeof error.error === 'string') {
          snackbar.error(error.error);
        } else {
          snackbar.error('The requested data was not found.');
        }
      } else if (error.status === 403) {
        if (localStorage.getItem(LocalStorageToken)) {
          snackbar.error('You do not have permission to access this action.');
        }
      } else if (error.status === 500) {
        snackbar.error('An internal server error occurred. Please try again later.');
      } else if (error.status === 429) {
        snackbar.error('Too many requests. Please try again later.');
      } else {
        localStorage.removeItem(LocalStorageToken);
        accountService.setUser(null);
      }
      throw error;
    }),
  );
};
